module.exports = __webpack_public_path__ + "img/product-card-bg.0f3aeaf.webp";